import SetupRmSn9sSmsModal from './setup-rm-sn9s-sms-modal.vue'
export default SetupRmSn9sSmsModal
